import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import useDocumentTitle from '../../hooks/DocumentTitle/documentTitle';
import { Modal } from '../Modal/Modal.component';
import { LeavePrompt } from '../Prompt/LeavePrompt/LeavePrompt.component';
import { SystemSettingsDialogContent } from './SystemSettingsDialogContent/SystemSettingsDialogContent.component';

interface SystemSettingsProps {
  onClose: () => void;
}

export const SystemSettings: React.FC<SystemSettingsProps> = ({ onClose }) => {
  const { t } = useTranslation();
  useDocumentTitle(t('systemSettings:systemModalTitles.title'));
  const [isDataChanged, setIsDataChanged] = useState<boolean>(false);
  const [isLeavePromptOpen, setIsLeavePromptOpen] = useState<boolean>(false);

  const onDataChanged = (isChanged?: boolean) => {
    setIsDataChanged(isChanged ?? false);
  };

  const onSave = () => {
    setIsDataChanged(false);
  };

  return (
    <Modal
      xCloseButton={() => (isDataChanged ? setIsLeavePromptOpen(true) : onClose())}
      open={true}
      size="xl"
      title={t('systemSettings:systemModalTitles.title')}
      heightReducing
    >
      <SystemSettingsDialogContent
        onClose={onClose}
        onCancel={onClose}
        onChange={onDataChanged}
        onSave={onSave}
        activeTab={t('systemSettings:systemModalTitles.flagSystem')}
      />
      <LeavePrompt isOpen={isLeavePromptOpen} onConfirm={onClose} onCancel={() => setIsLeavePromptOpen(false)} />
    </Modal>
  );
};
